import React from "react";
import { connect } from "react-redux";
import { isNil, partial } from "ramda";
import InputSync from "components/InputSync";
import {
  changeModuleCardField,
  saveNewModuleCardField,
  saveNewModuleCardFieldSuggestAsInternalCode,
  syncModuleCardField,
  syncModuleCardInternalCode,
} from "manage-modules/redux/manageModulesActions";
import { firstError } from "util/validation";

const ModuleDetailsTab = ({
  errors,
  fetchingInternalCodeSuggestion,
  fields,
  isNew,
  onChangeField,
  onSaveField,
  onSaveSuggestInternalCode,
  onSyncField,
  onSyncInternalCode,
  syncingFields,
}) => (
  <div>
    <InputSync
      type="text"
      label="Identifier (aka Internal Code)"
      name="internalCode"
      value={fields.internalCode}
      onChange={partial(onChangeField, ["internalCode"])}
      onBlur={
        isNew
          ? partial(onSaveSuggestInternalCode, [
              "internalCode",
              fields["internalCode"],
            ])
          : partial(onSyncInternalCode, [fields["internalCode"]])
      }
      maxLength={255}
      error={firstError(errors, "internalCode")}
      syncing={
        fetchingInternalCodeSuggestion || !isNil(syncingFields["internalCode"])
      }
    />
    <InputSync
      type="text"
      label="Default Curation Name"
      name="defaultCurationName"
      value={fields.defaultCurationName}
      onChange={partial(onChangeField, ["defaultCurationName"])}
      onBlur={
        isNew
          ? partial(onSaveField, [
              "defaultCurationName",
              fields["defaultCurationName"],
            ])
          : partial(onSyncField, [
              "defaultCurationName",
              fields["defaultCurationName"],
            ])
      }
      maxLength={100}
      error={firstError(errors, "defaultCurationName")}
      syncing={!isNil(syncingFields["defaultCurationName"])}
    />

    <InputSync
      type="text"
      label="Description"
      name="description"
      multiline={true}
      value={fields.description}
      onChange={partial(onChangeField, ["description"])}
      onBlur={
        isNew
          ? partial(onSaveField, ["description", fields["description"]])
          : partial(onSyncField, ["description", fields["description"]])
      }
      maxLength={4096}
      error={firstError(errors, "description")}
      syncing={!isNil(syncingFields["description"])}
    />
  </div>
);

const mapStateToProps = state => {
  const { moduleCard } = state.manageModules;
  const { errors, fetchingInternalCodeSuggestion, module, fields } = moduleCard;
  const syncingFields = state.manageModules.syncingFields[module.id] || {};

  return {
    errors,
    fetchingInternalCodeSuggestion,
    fields,
    isNew: !module.id,
    syncingFields,
  };
};

const mapDispatchToProps = dispatch => ({
  onChangeField: (field, value) =>
    dispatch(changeModuleCardField(field, value)),
  onSaveField: (field, value) => dispatch(saveNewModuleCardField(field, value)),
  onSaveSuggestInternalCode: (field, value) =>
    dispatch(saveNewModuleCardFieldSuggestAsInternalCode(field, value)),
  onSyncField: (field, value) => dispatch(syncModuleCardField(field, value)),
  onSyncInternalCode: internalCode =>
    dispatch(syncModuleCardInternalCode(internalCode)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ModuleDetailsTab);
